import { Component, createSignal, onMount, Show } from 'solid-js'
import { parse } from 'valibot'
import { backendAxios } from '../axios'
import AlertBag from '../components/AlertBag'
import Loader from '../components/Loader'
import { createAlertBagStore, setAlertBagError, setAlertBagSuccess } from '../rx/store/AlertBag'
import { PatchMyProfileBodySchema } from '../backend_schemas'

const ProfilePage: Component = () => {
  const [profile, setProfile] = createSignal<unknown>(null)
  const [isLoading, setIsLoading] = createSignal<boolean>(false)
  const alertBag = createAlertBagStore()

  const [dname, setDname] = createSignal<string>('')
  const [bio, setBio] = createSignal<string>('')

  onMount(async () => {
    setIsLoading(true)
    try {
      const response = await backendAxios.get('/profile/me')
      setProfile(response.data)
      setDname(response.data.dname || '')
      setBio(response.data.bio || '')
    } catch (err) {
      setAlertBagError(alertBag, err as Error)
    } finally {
      setIsLoading(false)
    }
  })

  const handleUpdate = async (e: Event) => {
    e.preventDefault()
    setIsLoading(true)
    setAlertBagError(alertBag, null)
    try {
      const payload = {
        dname: dname(),
        bio: bio(),
      }
      const validated = parse(PatchMyProfileBodySchema, payload)
      await backendAxios.patch('/profile/me', validated)
      setAlertBagSuccess(alertBag, 'Profile updated successfully')
    } catch (err) {
      setAlertBagError(alertBag, err as Error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div class="container mt-5">
      <h2>Profile</h2>
      <AlertBag store={alertBag} />
      <Show when={profile()} fallback={<Loader />}>
        <form onSubmit={handleUpdate}>
          <div class="mb-3">
            <label class="form-label">Display Name</label>
            <input
              type="text"
              class="form-control"
              value={dname()}
              onInput={(e) => setDname(e.currentTarget.value)}
              disabled={isLoading()}
            />
          </div>
          <div class="mb-3">
            <label class="form-label">Bio</label>
            <textarea
              class="form-control"
              value={bio()}
              onInput={(e) => setBio(e.currentTarget.value)}
              disabled={isLoading()}
            />
          </div>
          <button type="submit" class="btn btn-primary" disabled={isLoading()}>
            {isLoading() ? <Loader /> : 'Update Profile'}
          </button>
        </form>
      </Show>
    </div>
  )
}

export default ProfilePage
